import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Tiu Nombro estis tiom nerimarkinda, ke staris eĉ pli malalte ol la Nulo, sen paroli jam pri aliuj pozitivaj nombroj. 
      Tial, nekontenta pro sia stato, ĝi ĉion neis kaj staris ĉiam kun minusa signo.
    </p>
    
    <p class="mb-3">
      Sed jen ĉio ŝanĝiĝis. La Nombro estis potencita kaj fariĝis pozitiva. 
      Nun ĝi ekhavis potencon kaj tuj komencis konfirmi tion, kion antaŭe neis, kaj kontesti aliujn negativajn nombrojn, - tiujn pitajn, nerimarkindajn entjerojn, kiuj staras pli malalte ol la Nulo.
    </p>
    
    <p class="mb-3">
      Minuso multobligita al minuso fariĝas pluso: estas simpla aritmetika regulo.
    </p>
    `
  )
}

const itemName = {
  esp: 'Negativa nombro'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;